module.exports = __webpack_public_path__ + "img/trade.a766837d.svg";